module.exports = __webpack_public_path__ + "img/filter_item.b20e1901.png";